module.exports = __webpack_public_path__ + "static/media/lona.fd41e6b4.jpg";